document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartFooter', () => {
    return {
      footerRoot: null,
      async _morphFooter(e) {
        const data = e.detail && e.detail.response;
        let html = null;
        if (e.detail && e.detail.epoch != null) {
          await ensureSidecarCartSections(data);
          if (!isCurrentSidecarCartEpoch(e.detail.epoch)) return;
          html = data && data.sections ? data.sections['cart-footer'] : null;
        } else {
          const epochAtStart = window.__sidecarCartEpoch || 0;
          const fresh = await fetchSidecarCartSections({ force: true });
          if ((window.__sidecarCartEpoch || 0) !== epochAtStart) return;
          html = fresh && fresh['cart-footer'];
        }
        const root =
          (this.$root && this.$root.isConnected && this.$root) ||
          document.querySelector('.custom-cart-drawer [data-cart-footer]');
        if (!html || !root) return;
        this.footerRoot = root;

        const incoming = querySelectorInHTMLString('[data-cart-footer]', html);
        if (!incoming) return;
        const incomingHasTotals = !!incoming.querySelector('.custom-cart-footer__subtotal, .custom-cart-footer__checkout');
        const storeCount = window.Alpine && Alpine.store('cart_count') ? Number(Alpine.store('cart_count').count) || 0 : 0;
        if (!incomingHasTotals && (storeCount > 0 || window.__sidecarCartFlushing)) return;

        root.replaceChildren(
          ...Array.from(incoming.cloneNode(true).childNodes)
        );
      },
      init() {
        this.footerRoot = this.$root;
        this._onCartEvent = (e) => this._morphFooter(e);
        window.addEventListener('shapes:modalcart:afteradditem', this._onCartEvent);
        window.addEventListener('shapes:modalcart:cartqtychange', this._onCartEvent);
      },
      destroy() {
        window.removeEventListener('shapes:modalcart:afteradditem', this._onCartEvent);
        window.removeEventListener('shapes:modalcart:cartqtychange', this._onCartEvent);
      },
    };
  });
});
